// extracted by mini-css-extract-plugin
module.exports = {"root":"Button_root__3LFmi","default":"Button_default__1m6xI","primary":"Button_primary__2RkTt","danger":"Button_danger__1tt4f","good":"Button_good__1eju7"};